import React from 'react';
import { Text, TextTypes } from '../index';
import { Col } from 'react-bootstrap';
import './text-group.scss';

interface TextGroupProps {
    label: string;
    value: any;
    valueType?: any;
}

const TextGroup = ({ label, value, valueType }: TextGroupProps) => {
    return (
        <Col className={'text-group' + (label === 'Message' ? ' message' : '')}>
            <Text type={TextTypes.LABEL2} className="label">
                {label}
            </Text>
            <Text type={valueType || TextTypes.P} className="value">
                {value}
            </Text>
        </Col>
    );
};

const TextGroup2 = ({ label, value }: TextGroupProps) => {
    return (
        <Col className="text-group group-2">
            <Text type={TextTypes.LABEL2} className="label">
                {label}
            </Text>
            <Text type={TextTypes.H4} className="value">
                {value}
            </Text>
        </Col>
    );
};

export { TextGroup, TextGroup2 };
